// 发布项目模块
export default {
    PublishProject: {
        StartPublishing: 'Start publishing',
        ShareableQuestionnaire: 'After publising, you can share the questionnaire',
        ProjectSharing: 'Project sharing',
        LinkRemainsUnchanged: 'After the project is released, the link and QR code remain unchanged',
        ShareLink: 'Share Link',
        Copy: 'Copy',
        Open: 'Open',
        QRCode: 'QR code',
        DownloadQRCode: 'Download QR code',
        WeChatSharing: 'WeChat sharing',
        UploadLogo: 'Upload Logo',
        ShareLogo: 'Share Logo',
        ClickToUpload: 'Click to upload',
        ClickToDelete: 'Click to delete',
        ImageSupport: 'The image supports png and jpg formats, with a recommended size of 100 * 100',
        InputContent: 'Please enter the name of the contact person',
        ShareTitle: 'Share Title',
        ShareDescriptionDescription: 'Share Description Description',
        FriendSharingPreview: 'Friend sharing preview',
        ShareMomentPreview: 'Share Moment Preview',
        WeChatAvatar: 'WeChat avatar',
        WeChatNickname: 'WeChat nickname',
        SMSSharing: 'SMS sharing',
        ViewSentTextMessages: 'View sent text messages',
        AddRecipient: 'Add recipient',
        EditContent: 'Edit Content',
        Sent: 'Sent',
        BriefIntroduction: 'You can add from the contact list on the left, or manually enter "phone number, name". Each line represents a contact, and the name can appear in the text of the message. For example: 136xxxxxxxx, Mr. Song',
        ContactList: 'Contact list',
        Add: 'Add',
        ManuallyEnteringContacts: 'Manually entering contacts',
        NumberOfRecipients: 'Number of recipients',
        NextStep: 'Next step',
        InstructionsForUse: 'Instructions for use:',
        InstructionsForUse1: '1.The text message you sent needs to undergo content review',
        InstructionsForUse2: "2.The header of the message will be displayed as' Dongfang Aixue's agent '",
        InstructionsForUse3: '3.After successful sending, you can view the progress of the sent text messages',
        InstructionsForUse4: '4.$[name] represents the contact name $[surveylink] represents the questionnaire address',
        InstructionsForUse5: '5.Sending text messages to abnormal phone numbers (including downtime, empty numbers, etc.) will also deduct the balance of the text message or account balance',
        Back: 'Back',
        Sending: 'Sending',
        SubmittedForSending: 'Submitted for sending.',
        SMSSent: 'SMS sent',
        SMSContent: 'SMS content',
        NumberOfSenders: 'Number of senders',
        SendingTime: 'Sending time',
        State: 'State',
        SMSDelivered: 'SMS delivered',
        SMSNotDelivered: 'SMS not delivered',
        SMSDeliveryFailed: 'SMS delivery failed',
        Reason: 'Reason',
        Operate: 'Operate',
        ViewDetails: 'View details',
        BackSentSMSList: 'Return to the list of sent SMS messages',
        PhoneNumber: 'Phone number',
        Name: 'Name',
        Success: 'Success',
        Fail: 'Fail',
        EmailSharing: 'Email sharing',
        ViewSharedEmails: 'View shared emails',
        SelectSendingMethod: 'Select sending method',
        EmailContactDescription: "You can batch add from the 'Address Book' on the left, or manually enter the recipient's email (or 'email, name') on the right. Add up to 500 at a time.",
        InstructionsForUse: "Instructions for use: '$[name]' represents the recipient's name, '$[surveylink]' represents the evaluation address",
        Addresser: 'Addresser',
        SenderEmail: 'Sender email',
        Theme: 'Theme',
        SendViaEmail: 'Send using the SurveyTree email',
        SendViaEmail1: "Unified display of the questionnaire's email address: research@surveytree.org",
        SendViaEmail2: 'Each email consumes one email balance, needs to yop up email balance.',
        MailRemaining: 'Mail Remaining',
        RechargePurchase: 'Top up',
        SendUsingYourOwnEmail: 'Send using your own email',
        BindingRequired: 'It is necessary to bind personal or company email to display your outgoing email address, improve the brand image, do not consume email balance, and have a more reliable delivery success rate.',
        LimitedToAdvancedVersionUse: 'Limited to advanced version use',
        UpgradeNow: 'Upgrade now',
        NotYetOpen: 'Not yet open',
        SentMail: 'Sent mail',
        EmailSubject: 'Email Subject',
        SendingMethod: 'Sending method',
        Undelivered: 'Undelivered',
        Delivered: 'Delivered',
        DeliveryFailed: 'Delivery failed',
        BackToTheListOfSentEmails: 'Return to the list of sent emails',
        Mailbox: 'Mailbox',
        None: 'None',
        SendConfirmation: 'Send Confirmation',
        ContentContainsCharacters: 'The content contains the number of characters',
        NumberOfConsumptionItems: 'Number of remaining SMS messages to be consumed',
        NumberOfContactsToBeSent: 'This text message will send the number of contacts',
        TotalConsumptionSMSBalance: 'Total consumption SMS balance',
        SMSBalance: 'SMS balance',
        Strip: 'Strip',
        Recharge: 'Recharge',
        ReturnToModification: 'Return to modification',
        ModificationPrompt: 'Modification prompt',
        AreYouSureToModifyThisQuestionnaire: 'Are you sure to modify this questionnaire? All data collection for this questionnaire will be stopped, and the answer sheet link will be temporarily closed!',
        Wildcard: '$[surveylink] is a wildcard character representing the unique link to the questionnaire, please do not delete it! After deletion, the recipient will not be able to see the address. Click OK to add $[surveylink] again',
        QuestionControl: 'Question control',
        MyQuestionBank: 'My question bank',
        ForExample: 'For example',
        Recipient: 'For example, Dongfang Ai Xue',
        Investigate: 'Survey of Spirit Questionnaire Course',
        TelephoneSurveys: 'Telephone surveys',
        Interview: 'Interview',
        SetUp: 'Set up',
        PleaseWaitAMoment: 'Please wait a moment',
        InsufficientSMSBalance: 'Insufficient SMS balance, please recharge in a timely manner',
        SuccessfullySent: 'Successfully sent',
        NoContactsToSend: 'You have no contacts to send',
        FillInTheEmailSubject: 'Please fill in the email subject!',
        InsufficientEmailBalance: 'Insufficient email balance, please recharge and purchase!',
        SuccessfullyCopied: 'Successfully copied!',
        AndaPastiInginMenerbitkan: 'Are you sure you want to publish',
        Penerbitan: 'Publishing in progress, please wait',
        BerjayaDiterbitkan: 'Successfully published!',
        TidakDiterbitkan: 'Unpublished',
        SetBerjaya: 'Successfully set',
        PadamSecaraKekal: 'This operation will permanently delete the data. Do you want to continue?'

    },
  };